import { useGetPowerBiTokenForReport } from 'api/generated/power-bi-controller/power-bi-controller';

/**
 * Thin wrapper so presentational code never imports Orval-generated hooks directly
 * (see `code-guidelines.mdc` / Orval integrator boundary rule).
 */
export const usePowerBiTokenMutation = useGetPowerBiTokenForReport;
